'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BibBrief = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _immutable = require('immutable');

var _immutable2 = _interopRequireDefault(_immutable);

var _reactIntl = require('react-intl');

var _baseByAuthorBlock = require('@bibliocommons/base-by-author-block');

var _baseByAuthorBlock2 = _interopRequireDefault(_baseByAuthorBlock);

var _sharedBibTitle = require('@bibliocommons/shared-bib-title');

var _sharedBibTitle2 = _interopRequireDefault(_sharedBibTitle);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

require('../styles/BibBrief.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BibBrief = exports.BibBrief = function (_BcReactComponent) {
  _inherits(BibBrief, _BcReactComponent);

  function BibBrief(props) {
    _classCallCheck(this, BibBrief);

    var _this = _possibleConstructorReturn(this, (BibBrief.__proto__ || Object.getPrototypeOf(BibBrief)).call(this, props));

    _this.bindAll('focusOnTitle');
    return _this;
  }

  _createClass(BibBrief, [{
    key: 'getBib',
    value: function getBib() {
      return this.props.bib ? this.props.bib : _immutable2.default.fromJS({
        title: this.props.fallbackTitle || this.props.intl.formatMessage({ id: 'undetermined_item' }),
        id: ''
      });
    }
  }, {
    key: 'getAuthors',
    value: function getAuthors() {
      var bib = this.getBib();
      var authors = bib.get('authors', _immutable2.default.List());

      if (bib.get('multiscriptAuthor')) {
        authors = authors.unshift(bib.get('multiscriptAuthor'));
      }

      return authors;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          titleTag = _props.titleTag,
          children = _props.children,
          anchorTarget = _props.anchorTarget,
          renderTitleAsLink = _props.renderTitleAsLink,
          renderAuthorsAsLink = _props.renderAuthorsAsLink,
          renderIcon = _props.renderIcon,
          truncateTitleOptions = _props.truncateTitleOptions;

      var bib = this.getBib();

      return _react2.default.createElement(
        'div',
        { className: 'cp-bib-brief' },
        _react2.default.createElement(_sharedBibTitle2.default, {
          title: bib.get('title'),
          format: bib.get('format'),
          subtitle: bib.get('subtitle'),
          primaryLanguage: bib.get('primaryLanguage'),
          multiscriptTitle: bib.get('multiscriptTitle'),
          ref: function ref(el) {
            return _this2._bibTitle = el;
          },
          id: bib.get('id'),
          titleTag: titleTag,
          target: anchorTarget,
          renderAsLink: renderTitleAsLink,
          renderIcon: renderIcon,
          truncateOptions: truncateTitleOptions }),
        _react2.default.createElement(_baseByAuthorBlock2.default, {
          authors: this.getAuthors(),
          target: anchorTarget,
          renderAsLink: renderAuthorsAsLink }),
        children
      );
    }
  }, {
    key: 'focusOnTitle',
    value: function focusOnTitle() {
      if (this._bibTitle) {
        this._bibTitle.getWrappedInstance().focusOnTitle();
      }
    }
  }]);

  return BibBrief;
}(_baseBcReactComponent2.default);

BibBrief.displayName = 'BibBrief';

BibBrief.defaultProps = {
  children: null,
  anchorTarget: '_parent',
  renderTitleAsLink: true,
  renderAuthorsAsLink: true
};

BibBrief.propTypes = {
  bib: _bcPropTypes.bibBriefShape,
  children: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.node), _react.PropTypes.node]),
  renderIcon: _react.PropTypes.func,
  titleTag: _react.PropTypes.string,
  anchorTarget: _react.PropTypes.string,
  renderTitleAsLink: _react.PropTypes.bool,
  renderAuthorsAsLink: _react.PropTypes.bool,
  truncateTitleOptions: _bcPropTypes.truncateOptionsShape,
  fallBackTitle: _react.PropTypes.string
};

exports.default = (0, _reactIntl.injectIntl)(BibBrief);


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/shared-bib-brief/lib/components/BibBrief.component.js
// module id = 1470
// module chunks = 1